import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { Box, Button, CardActionArea, Grid2 } from '@mui/material';
import { CustomTooltip } from '../utils/CustomTooltip';
import { Formik, Field, Form } from "formik";
import * as Yup from "yup";
import { useToaster } from '../utils/ToasterProvider';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import { TextFormField } from './FormFields/TextFormField';
// import api from '../../assets/api/usePostApi';
import MainDialogBox from './Dialog/DialogMainBox';
import { useDialog } from '../hook/useDialog';
import { PhoneInputFormField } from './FormFields/PhoneInputFormField';
import CheckIcon from "@mui/icons-material/Check";
import { ImagePath } from '../constants';
import { isValidPhoneNumber } from 'react-phone-number-input';
import CustomDivider from '../utils/CustomDivider';
import api from '../../assets/nodeApi/axiosInstance';


const PollingCard = ({ item }) => {
    const { image_path
        , course_id, apartment_id, apartment_name, student_id, student_name, total_votes, parent_name } = item
    const [isOtpSent, setIsOtpSent] = useState(false)
    const { showToaster } = useToaster();
    const queryClient = useQueryClient();
    const { open, handleClickOpen, handleClose } = useDialog();
    const initialValues = {
        voter_name: "",
        mobile_no: "",
        otp: ""
    };

    const validationSchema = Yup.object().shape({
        voter_name: Yup.string().required("Voter name is required"),
        mobile_no: Yup.string().test("is-phone", "Invalid phone number", function (value) {
            return value ? isValidPhoneNumber(value) : false;
        }),
        otp: Yup.string().when("isOtpSent", {
            is: true,
            then: Yup.string().required("OTP is required")
        }).required("Otp is required")
    });

    const sendOtpMutation = useMutation({
        mutationFn: (formData) => api.post("send-otp", formData),
    });
    const handleCheckOtp = (value) => {
        sendOtpMutation.mutate({ mobile: value }, {
            onSuccess: (response) => {
                if (response?.data?.message) {
                    setIsOtpSent(true)
                }
            },
            onError: (error) => {
                showToaster(error?.data?.message, 'Error', 'error')
            },
        });
    }
    const mutationVote = useMutation({
        mutationFn: (formData) => api.post(`verify-otp-and-vote`, formData,),
    });
    const handleSubmit = (values, { setSubmitting, resetForm }) => {
        const payload = {
            course_id: course_id,
            candidate_id: student_id,
            apartment_id: apartment_id,
            ...values
        }
        mutationVote.mutate(payload, {
            onSuccess: (response) => {
                if (response?.data?.message) {
                    showToaster('Success', response?.data?.message, 'success');
                    queryClient.invalidateQueries({ queryKey: ['student-poling-images'] });
                    handleClose()
                } else {
                    showToaster('Error', "Something went wrong1", 'error');
                }
                resetForm();
            },
            onError: (error) => {
                if (error?.response?.status === 400 || error?.response?.status === 409) {
                    showToaster(
                        'Error',
                        error?.response?.data?.message || "Bad request",
                        'error'
                    );
                } else {
                    showToaster(
                        'Error',
                        "Something Went wrong while Submitting form",
                        'error'
                    );
                }
            },
            onSettled: () => {
                setSubmitting(false);
            },
        });
    }



    return (
        <>
            <Card sx={{ boxShadow: "none", my: 1, borderRadius: "2rem", bgcolor: "primary.light", width: "100%", }}>
                <CardActionArea sx={{ width: "100%", height: "100%", display: "flex", flexDirection: "column", justifyContent: "start" }} >
                    <CardContent
                        sx={{
                            backgroundImage: `url("${image_path}")`,
                            backgroundSize: "cover",
                            backgroundPosition: "start",
                            height: "350px",
                            width: "100%",
                            borderTopRightRadius: "40px",
                            borderTopLeftRadius: "40px",
                            py: { xs: 2, lg: 3 },
                            px: { xs: 2, lg: 5 }

                        }}
                    >
                        <CustomTooltip number={total_votes} icon='material-symbols:thumb-up-rounded' />
                    </CardContent>
                    <CardContent sx={{ width: "100%", }}>
                        <Box sx={{ display: "flex", justifyContent: "space-between", px: 3, py: 3, alignItems: "center" }}>
                            <Box>
                                <Typography variant="body1">By {student_name}</Typography>
                                {/* <Typography variant="body2" fontWeight={200}>Child's Name : {student_name} </Typography> */}
                                <Typography variant="body2" fontWeight={200}>Parent's Name : {parent_name}</Typography>
                            </Box>

                            <Button variant='contained' component="div" onClick={(e) => {
                                e.stopPropagation();
                                handleClickOpen();
                            }}>Vote Now</Button>
                        </Box>

                    </CardContent>
                </CardActionArea>
            </Card>
            <MainDialogBox open={open} handleClose={handleClose} width={"60%"}>
                <Formik initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={handleSubmit}>
                    {({ isValid, dirty }) => (
                        <Form>
                            <Grid2 container spacing={"2rem"}>

                                <Grid2 children size={{ xs: 12, md: 6 }}>
                                    <Field
                                        name="voter_name"
                                        component={TextFormField}
                                        label="Enter Your Name"
                                        isRequired={true}
                                    />
                                </Grid2>
                                <Grid2 children size={{ xs: 12, md: 6 }}>
                                    <Field name="mobile_no">
                                        {({ field, form }) => (
                                            <PhoneInputFormField
                                                field={field}
                                                form={form}
                                                label="Enter your WhatsApp number"
                                                isRequired={true}
                                                disabled={isOtpSent}
                                                isOtpSent={isOtpSent}
                                                endIcon={<CheckIcon />}
                                                OnButtonClick={async () => {
                                                    await form.validateField("mobile_no");
                                                    const error = form.errors?.mobile_no;
                                                    if (!error) {
                                                        handleCheckOtp(field.value);
                                                    } else {
                                                        form.setFieldTouched("mobile_no", true, true);
                                                    }
                                                }}
                                            />
                                        )}
                                    </Field>
                                    {
                                        isOtpSent && <Typography variant="body2" color="grey" mt={2}>
                                            Otp has Sent
                                        </Typography>
                                    }
                                </Grid2>

                                {isOtpSent && <Grid2 children size={{ xs: 12, md: 6 }}>
                                    <Field
                                        name="otp"
                                        component={TextFormField}
                                        label="Please enter the OTP you received via WhatsApp"
                                        isRequired={true}
                                    />
                                </Grid2>}




                            </Grid2>
                            <CustomDivider />
                            <Grid2 container spacing={"2rem"}>
                                <Grid2 children size={{ xs: 6, md: 4 }}>
                                    <Button variant="outlined" fullWidth onClick={handleClose}>Cancel</Button>
                                </Grid2>
                                <Grid2 children size={{ xs: 6, md: 4 }}>
                                    <Button variant="contained" type="submit" fullWidth disabled={!(isValid && dirty)}>Submit</Button>
                                </Grid2>
                            </Grid2>
                        </Form>
                    )}
                </Formik>
            </MainDialogBox>
        </>
    )
}

export default PollingCard



